import Header from "../../Components/Header/Header";
import storyImage_en from "../../images/ourStory_en.png";
import storyImage_ar from "../../images/ourStory_ar.png";
import VisionImage_en from "../../images/ourVision_en.png";
import VisionImage_ar from "../../images/ourVision_ar.png";
import MissionImage from "../../images/our_mission.jpg";
import { Fragment } from "react";

// import i18next from 'i18next';
import { useTranslation } from "react-i18next";

import "./about.css";
const About = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Header
        bgTitle={document.body.dir === "ltr" ? "About Us" : "من نحن"}
      ></Header>
      <section className="about__story">
        <div className="container about__story-container">
          <div className="about__section-image">
            <img
              src={document.body.dir === "ltr" ? storyImage_en : storyImage_ar}
              alt="Our Story"
            />
          </div>
          <div className="about__section-content">
            <h1>{t("our_story")}</h1>
            <p>{t("our_story_first_p")}</p>
            <p>{t("our_story_second_p")}</p>
            <p>{t("our_story_third_p")}</p>
          </div>
        </div>
      </section>
      <section className="about__vision">
        <div className="container about__vision-container">
          <div className="about__section-content">
            <h1>{t("our_vision")}</h1>
            <p>{t("our_vision_first_p")}</p>
            <p>{t("our_vision_second_p")}</p>
          </div>
          <div className="about__section-image">
            <img
              src={
                document.body.dir === "ltr" ? VisionImage_en : VisionImage_ar
              }
              alt="Our vision"
            />
          </div>
        </div>
      </section>
      <section className="about__mission">
        <div className="container about__mission-container">
          <div className="about__section-image">
            <img src={MissionImage} alt="Our mission" />
          </div>
          <div className="about__section-content">
            <h1>{t("our_mission")}</h1>
            <p>{t("our_mission_first_p")}</p>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default About;
